import React from "react";
import configuration from "react-global-configuration";
import { resolveVideoAccessBadge, videoAccessType } from "./videoAccessBadgeConfig";
import "./VideoAccessBadge.css";

function badgeConfig() {
  try {
    return configuration.get("configData.video_access_badges") || null;
  } catch (e) {
    return null;
  }
}

/**
 * Free / Subscriber Only / PPV label for a video card or detail header.
 * Presentation only; renders nothing when the badge is hidden or the type is unknown.
 */
const VideoAccessBadge = ({ item, className }) => {
  const badge = resolveVideoAccessBadge(videoAccessType(item), badgeConfig());
  if (!badge) return null;

  return (
    <span
      className={"video-access-badge video-access-badge--" + badge.type + (className ? " " + className : "")}
      style={{ backgroundColor: badge.background, color: badge.text }}
    >
      {badge.iconClass ? <i className={badge.iconClass} aria-hidden="true" /> : null}
      {badge.label}
    </span>
  );
};

export default VideoAccessBadge;
